var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMob3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 144 144",
    id: "Layer_1",
    viewBox: "0 0 144 144",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.14,104.6v9.584   c0,6.25-5.066,11.316-11.316,11.316H50.664c-6.25,0-11.316-5.066-11.316-11.316V31.83c0-6.25,5.066-11.316,11.316-11.316h37.159   c6.25,0,11.316,5.066,11.316,11.316v22.03",
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.348,32v-0.17   c0-6.25,5.066-11.316,11.316-11.316h37.159c6.25,0,11.316,5.066,11.316,11.316V32H39.348z",
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.182,32v-0.17c0-6.25,5.066-11.316,11.316-11.316h37.159   c6.25,0,11.316,5.066,11.316,11.316V32H39.182z",
    fill: "#528AC8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.14,114.015v0.17   c0,6.25-5.066,11.316-11.316,11.316H50.664c-6.25,0-11.316-5.066-11.316-11.316v-0.17H99.14z",
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.14,114.015v0.17c0,6.25-5.066,11.316-11.316,11.316H50.664   c-6.25,0-11.316-5.066-11.316-11.316v-0.17H99.14z",
    fill: "#528AC8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 63.943,
    x2: 74.545,
    y1: 120.374,
    y2: 120.374
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 63.943,
    x2: 74.545,
    y1: 26.257,
    y2: 26.257
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.528,
    x2: 9.528,
    y1: 50.525,
    y2: 61.655
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 15.757,
    x2: 3.298,
    y1: 56.09,
    y2: 56.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.194,
    x2: 23.194,
    y1: 77.815,
    y2: 85.274
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.924,
    x2: 19.465,
    y1: 81.544,
    y2: 81.544
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.544,73.38    l3.94-1.709l-4.028-9.287l-4.532,1.965c-1.676-2.216-3.472-3.867-5.425-5.172l1.74-4.835l-9.567-3.864l-1.813,4.563    c-2.803-0.462-5.845-0.435-8.568,0.07l-1.748-4.029l-8.668,3.759l1.748,4.029c-3.468,2.18-4.789,3.984-6.368,6.347l-4.831-1.742    l-3.862,9.566l4.758,2.26c-0.382,2.317-0.454,4.78,0.019,7.517l-4.891,2.121l4.028,9.287l4.3-1.865    c1.819,2.889,4.094,5.006,6.856,6.852l-1.906,4.452l9.484,3.672l2.211-4.849c2.803,0.462,5.004,0.686,8.966-0.356l2.045,4.715    l8.668-3.759l-2.045-4.715c2.23-1.643,4.35-3.794,5.929-6.156l4.611,1.837l3.752-9.518l-4.481-1.471    C136.407,79.787,136.411,76.682,135.544,73.38z M117.738,92.764c-7.699,3.339-16.646-0.195-19.985-7.894    c-3.339-7.699,0.195-16.646,7.894-19.985c7.699-3.339,16.646,0.195,19.985,7.894C128.971,80.477,125.437,89.425,117.738,92.764z",
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.655,73.463l3.94-1.709l-4.028-9.287l-4.532,1.965    c-1.676-2.216-3.472-3.867-5.425-5.172l1.74-4.835l-9.567-3.864l-1.813,4.563c-2.803-0.462-5.845-0.435-8.568,0.07l-1.748-4.029    l-8.668,3.759l1.748,4.029c-3.468,2.18-4.789,3.984-6.368,6.347l-4.831-1.742l-3.862,9.566l4.758,2.26    c-0.382,2.317-0.454,4.78,0.019,7.517l-4.891,2.121l4.028,9.287l4.3-1.865c1.819,2.889,4.094,5.006,6.856,6.852l-1.906,4.452    l9.484,3.672l2.211-4.849c2.803,0.462,5.004,0.686,8.966-0.356l2.045,4.715l8.668-3.759l-2.045-4.715    c2.23-1.643,4.35-3.794,5.929-6.156l4.611,1.837l3.752-9.518l-4.481-1.471C136.517,79.87,136.521,76.765,135.655,73.463z     M117.738,92.764c-7.699,3.339-16.646-0.195-19.985-7.894c-3.339-7.699,0.195-16.646,7.894-19.985    c7.699-3.339,16.646,0.195,19.985,7.894C128.971,80.477,125.437,89.425,117.738,92.764z",
    fill: "#528AC8",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 47.36,
    x2: 83.36,
    y1: 44.555,
    y2: 44.555
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 47.36,
    x2: 72.36,
    y1: 55.555,
    y2: 55.555
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 125.445,
    x2: 125.445,
    y1: 28.457,
    y2: 39.587
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3D6CB4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 131.674,
    x2: 119.215,
    y1: 34.022,
    y2: 34.022
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMob3);
export default __webpack_public_path__ + "static/media/mob3.be2b4a058c97585c785911f5682066a0.svg";
export { ForwardRef as ReactComponent };